import { SxProps, Theme } from "@mui/material/styles";

export const styles: Record<string, SxProps<Theme>> = {
  form: (theme) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",

    borderRight: {
      xs: "none",
      md: `1px solid ${theme.colors.grey400}`,
    },

    overflowY: { xs: "auto", md: "hidden" },
  }),
  formContent: {
    flex: { xs: "1 0 auto", md: "1 1 auto" },
    minHeight: 0,
    overflowY: { xs: "visible", md: "auto" },

    p: {
      xs: "16px",
      sm: "24px 80px",
      md: "24px 40px",
      lg: "24px 60px",
    },
  },
  buttonWrapper: {
    flex: "0 0 auto",
    backgroundColor: "white",
    borderTop: { xs: "none", md: "1px solid #E0E0E0" },
    zIndex: 10,
    p: {
      xs: "16px",
      sm: "24px 80px",
      md: "24px 40px",
      lg: "24px 60px",
    },
  },
  skeleton: {
    mb: 2,
    borderRadius: 1,
  },
};
